import { H } from 'highlight.run';

export function identifyUserWithHighLightIo(user) {
  try {
    console.log("HighLightIo identity", user);
    H.identify(user.id, {
      name: user.name,
      email: user.email,
      role: user.role,
    });
  } catch (err) {
    console.log("HighLightIo identity:err", err);
  }
}